"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.Confirm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var ui_components_1 = require("@codametrix/ui-components");
var noOpHandler = function (actionItem) { };
var DEFAULT_PROPS = {
    display: true,
    onConfirm: noOpHandler,
    onDismiss: noOpHandler,
    actionItem: {
        action: 'STANDARD_ACTION'
    },
    strings: {
        proceed: 'Accept',
        dismiss: 'Cancel'
    }
};
var Confirm = function (passed) {
    var props = __assign(__assign({}, DEFAULT_PROPS), passed);
    var title = props.title, strings = props.strings;
    var helpText = props.helpText ? (0, jsx_runtime_1.jsx)("p", { children: props.helpText }) : (0, jsx_runtime_1.jsx)("span", {});
    var handleConfirm = function (event) {
        event.preventDefault();
        props.onConfirm(props.actionItem);
    };
    var handleDismiss = function (event) {
        event.preventDefault();
        props.onDismiss(props.actionItem);
    };
    var footerChildren = ((0, jsx_runtime_1.jsxs)("div", __assign({ className: 'confirm-text' }, { children: [(0, jsx_runtime_1.jsxs)(ui_components_1.RoundedButton, __assign({ className: 'btn btn-primary btn-sm qa-submit-button auto-focus-btn', autoFocus: true, onClick: handleConfirm }, { children: [' ', strings.proceed] })), (0, jsx_runtime_1.jsx)("span", __assign({ className: 'column col-1' }, { children: "or" })), (0, jsx_runtime_1.jsx)("a", __assign({ href: "#/dismiss-confirm", tabIndex: 0, className: 'qa-cancel-button ', onClick: handleDismiss }, { children: strings.dismiss }))] })));
    return props.display ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "confirm" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.Modal, __assign({ footerChildren: footerChildren, closable: false, title: title }, { children: helpText })) }))) : null;
};
exports.Confirm = Confirm;
exports.Confirm.displayName = 'Confirm';
//# sourceMappingURL=confirm.js.map